import React from "react";
import styled from "styled-components";

export default function Input({ type, label, placeholder, id }) {
  return (
    <StyledInput>
      <label htmlFor={id}>{label}</label>
      <input type={type} id={id} placeholder={placeholder} />
    </StyledInput>
  );
}

const StyledInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    color: var(--text-2);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 135.714% */
    padding-left: 20px;
  }

  input {
    padding: 18px 20px;
    outline: none;
    border-radius: 30px;
    border: 1px solid var(--border);
    background-color: var(--white);
    color: var(--text-2);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 147.059% */
    transition: 0.4s ease;

    &::placeholder {
      color: var(--secondary);
    }

    &:hover,
    &:focus {
      border-color: var(--light-blue);
    }
  }
`;
